// libs
import React, { useRef, useMemo } from 'react'
import { Grid, Box, ButtonBase } from '@material-ui/core'

// assets
import * as S from './styles'
import { ReactComponent as FileIcon } from 'presentation/assets/icons/file-icon.svg'
import { ReactComponent as DeleteIcon } from 'presentation/assets/icons/FileDeleteIcon.svg'
import { ReactComponent as ViewIcon } from 'presentation/assets/icons/eye-dark-gray.svg'
import { ReactComponent as DownloadIcon } from 'presentation/assets/icons/DonwloadIcon.svg'

const allowedFileViewTypes = /(jpg|jpeg|png|gif|pdf)$/i

export interface FileViewProps {
  sectionId: string
  fileId?: string
  file: File
  uploadedAt: Date
  isEditable?: boolean
  onFileDelete: (fileId?: string) => void
  onFileView?: (fileId?: string) => void
  onFileUpload?: (evt: File) => void
  onFileDownload?: (fileId?: string) => void
}

function FileView({
  sectionId,
  fileId,
  file,
  uploadedAt,
  onFileDelete,
  onFileView,
  isEditable,
  onFileUpload,
  onFileDownload
}: FileViewProps) {
  const labelRef = useRef<HTMLLabelElement | null>(null)

  const handleUploadClick = () => {
    if (labelRef.current) labelRef.current.click()
  }

  const handleUploadChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    if (evt.target.files) {
      const files = evt.target.files

      const file = files[0]
      if (file && onFileUpload) onFileUpload(file)
    }
  }

  const fileRefId = `FileView-uploadInput-${sectionId}`

  const canView = useMemo<boolean>(() => {
    if (file) {
      const extension = file.name.split('.').pop()
      return (
        allowedFileViewTypes.test(file.type) ||
        allowedFileViewTypes.test(extension ?? '')
      )
    }

    return false
  }, [file])

  return (
    <Box bgcolor="white" borderRadius="10px" p={2} height="150px">
      <input
        type="file"
        value=""
        style={nonDisplay}
        id={fileRefId}
        accept={
          'image/jpeg,image/gif,image/png,image/bmp,image/tif,image/tiff,application/pdf,image/x-eps,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.oasis.opendocument.text,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.oasis.opendocument.spreadsheet'
        }
        onChange={handleUploadChange}
      />
      <label style={nonDisplay} htmlFor={fileRefId} ref={labelRef} />
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Box
            width="100%"
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <Box width="100%" display="flex" alignItems="center">
              <Box
                mr={1}
                p={1}
                bgcolor="#FEEFEF"
                display="flex"
                alignItems="center"
                justifyContent="center"
                borderRadius="8px"
              >
                <FileIcon />
              </Box>
              <S.FileName>{file.name}</S.FileName>
            </Box>
            {isEditable && (
              <ButtonBase onClick={() => onFileDelete(fileId)}>
                <DeleteIcon />
              </ButtonBase>
            )}
          </Box>
        </Grid>
        <Grid item xs={12}>
          <S.UploadText>
            {`Upload feito dia ${new Date(uploadedAt).toLocaleDateString()}`}
          </S.UploadText>
        </Grid>
        <Grid item xs={12}>
          <Box
            width="100%"
            display="flex"
            alignItems="center"
            gridColumnGap={'.5rem'}
          >
            {canView && (
              <ButtonBase
                onClick={() => {
                  if (onFileView) onFileView(fileId)
                }}
              >
                <Box display="flex" alignItems="center">
                  <Box mr={0.5}>
                    <ViewIcon />
                  </Box>
                  <S.UploadText>Visualizar</S.UploadText>
                </Box>
              </ButtonBase>
            )}

            {!canView && (
              <ButtonBase onClick={() => onFileDownload?.(fileId)}>
                <Box display="flex" alignItems="center">
                  <Box mr={0.5}>
                    <DownloadIcon />
                  </Box>
                  <S.UploadText>Download</S.UploadText>
                </Box>
              </ButtonBase>
            )}

            {isEditable && (
              <ButtonBase onClick={handleUploadClick}>
                <Box display="flex" alignItems="center">
                  <Box
                    mr={0.5}
                    style={{ transform: 'rotateX(180deg) translateY(1px)' }}
                  >
                    <DownloadIcon />
                  </Box>
                  <S.UploadText>Upload</S.UploadText>
                </Box>
              </ButtonBase>
            )}
          </Box>
        </Grid>
      </Grid>
    </Box>
  )
}

export { FileView }

const nonDisplay = { display: 'none' }
